module.exports = __webpack_public_path__ + "img/auth-bg-7f98619.jpg";